/* @flow */

export default {
  rootTooltip: {
    borderRadius: '10px !important',
    padding: 10,

    transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-out !important',
    opacity: '0 !important',
    visibility: 'visible',

    zIndex: '9999 !important', // Default is 999 but must be higher than 1300 because of Mui Popover

    '&.show': {
      visibility: 'visible',
      opacity: '1 !important',
    },
  },
};
